/**
 * Components: Cloud Image.
 *
 * @since 3.27.3
 */

/**
 * External dependencies
 */
import styled from "styled-components";

/**
 * @inheritDoc
 */
const IconImg = styled.img`
  border: 0;
  position: absolute;
  right: 20px;
  top: calc(50% - 10px);
  max-width: 20px;
  max-height: 20px;
`;

// Finally export the `IconImg`.
export default IconImg;
